import { b } from "@/b";
import { CURRENCY_FRAGMENT, CurrencyRenderer } from "./CurrencyRenderer";
import React, { useMemo } from "react";
import { FragmentData } from "@gqlb/core";

export const SubscriptionCurrency_Fragment = b.fragment(
  "SubscriptionCurrencyRender",
  "SubscriptionCurrency",
  (b) => [
    b.amount((b) => [b.__fragment(CURRENCY_FRAGMENT)]),
    b.interval(),
    b.intervalCount(),
  ]
);

export const SubscriptionCurrencyRenderer: React.FC<{
  data: FragmentData<typeof SubscriptionCurrency_Fragment>;
}> = ({ data }) => {
  const intervalLabel = useMemo(() => {
    const singular = data.intervalCount === 1;
    const c = data.intervalCount;
    switch (data.interval) {
      case "DAY":
        return singular ? "day" : `${c} days`;
      case "WEEK":
        return singular ? "week" : `${c} weeks`;
      case "MONTH":
        return singular ? "month" : `${c} months`;
      case "YEAR":
        return singular ? "year" : "years";
    }
  }, [data.interval, data.intervalCount]);

  return (
    <>
      <CurrencyRenderer data={data.amount} /> / {intervalLabel}
    </>
  );
};
